export default __webpack_public_path__ + "static/media/energy-orange.34f8952c.svg";